/**
 * Created by Mikhail Menshenin on 18.07.2024
 */

const MedalCollectionTool = {
    init: function () {
        if (cleverapps.config.features.includes("medalcollection")) {
            ToolModel.AUTONAVIGATE.push({
                windows: [MedalCollectionWindow],
                path: ["medalCollection"]
            });
        }
    },

    getToolItems: function () {
        const game = aisensia.medalCollection;

        const actions = {
            addMore: aisensia.medalCollection.addMore.bind(aisensia.medalCollection, 1),
            reset: function () {
                aisensia.medalCollection.reset();
                cleverapps.focusManager.closeAllWindows();
            }
        };

        const spawnAction = function (level) {
            return function () {
                game.addMore(1);
                game.spawn(level);
            };
        };
        const spawnMedalActions = {};
        // Labels go without medal names: the names live in the medalcollection bundle dictionary, not loaded until its window opens
        for (let level = 1; level <= MedalCollection.MAX_LEVEL; level++) {
            spawnMedalActions[`medal_${level}`] = spawnAction(level);
        }

        actions["choose medal"] = spawnMedalActions;

        return actions;
    }
};

cleverapps.Tool.medalCollection = ToolFolder.create(() => {
    if (cleverapps.config.features.includes("medalcollection")) {
        return MedalCollectionTool.getToolItems();
    }
});